import React, { Component } from 'react';

class ChannelResultItem extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  channelSelect = (id) => {
    console.log('id', id)
  }

  render() {
    const { channel, onChannelSelect, selectedChannels } = this.props;

    return (
      <label className="form-check">
        <input
          className="form-check-input mt-1"
          type="checkbox"
          checked={(selectedChannels || []).includes(channel.id)}
          value={channel.id}
          name="channel"
          onChange={() => onChannelSelect(channel.id)}
        />
        <span className="form-check-label">{channel.name}</span>
      </label>
    )
  }
}
export default ChannelResultItem;



// WEBPACK FOOTER //
// ./src/components/Picker/ChannelResultItem.js